import React = require("react");
import {Buttons} from "../buttons/Buttons";
import {ToolbarContextConsumer} from "./ToolbarContext";
import "./ToolSelector.scss";

interface ToolsSelectorProps {
    enabled: boolean;
    toolsAvailable: Tool[];
    activeToolKey: any;
    width: number;
    excelLoading?: boolean;
}

export interface Tool {
    key: any;
    name: string;
    icon: string;
    onClick: () => any;
}

interface ToolsSelectorState {
    toolSelectedKey: any;
}

export class ToolsSelector extends React.Component<ToolsSelectorProps, ToolsSelectorState> {
    constructor(props: ToolsSelectorProps) {
        super(props);
        this.state = {
            toolSelectedKey: props.toolsAvailable[0].key,
        };
    }

    public render() {
        const tools = this.props.toolsAvailable.map(
            (t, index) => {
                return (
                    <ToolbarContextConsumer key={"consumer" + index}>
                        {(context) =>
                            <Buttons.ButtonWithIcon
                                disabled={!this.props.enabled}
                                key={"toolButton" + t.key}
                                height={"50px"}
                                width={"50px"}
                                code={t.key}
                                icon={t.icon}
                                selected={t.key === context.toolSelectedKey}
                                loading={(this.props.excelLoading && t.key === "export")}
                                onClick={context.handleToolSelectedChange}
                            />
                        }
                    </ToolbarContextConsumer>
                );
            });
        return (
            <div className={"tool-selector__container"}>
                {tools}
            </div>
        );
    }
}
